.checkbox {
  line-height: 1;
}

.label {
  font-size: 12px;
}
